module.exports = __webpack_public_path__ + "static/media/Cinza-Fossil.89669473.png";